import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import { getAttendees } from './getAttendees.util.js';
import { getRecentAssuranceTasks } from './getRecentAssuranceTasks.util.js';
import { meetingAgendaTemplate as base64Docx } from './meetingAgendaTemplate.base64.js';
import { base64ToArrayBuffer } from './base64ToArrayBuffer.util.ts';

// Function to load the DOCX template from base64 and generate the document
async function generateDocumentFromBase64(data) {
    try {
        // Convert the base64-encoded string to an ArrayBuffer
        const content = base64ToArrayBuffer(base64Docx);

        // Create a zip instance for reading the docx file
        const zip = new PizZip(content);

        // Create an instance of docxtemplater to process the document
        const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
        });

        // Populate the template with the dynamic content
        doc.render(data);

        // Generate the new document as a blob
        const buf = doc.getZip().generate({ type: 'blob' });

        // Save the document using FileSaver.js
        saveAs(buf, `ISMS Meeting Agenda - ${(new Date().getMonth() + 1).toString().padStart(2, '0')}/${new Date().getFullYear().toString().slice(-2)}.docx`);

        console.log('Document generated successfully!');
    } catch (error) {
        console.error('Error generating document:', error);
    }
}

// Function to generate the meeting agenda
export async function generateMeetingAgenda(companyID, months = 3, completedOnly = true) {
    try {
        const attendees = await getAttendees(companyID);
        const assurance = await getRecentAssuranceTasks(companyID, months, completedOnly);

        // Format the data for docxtemplater
        const data = {
            date: new Date().toLocaleDateString('en-AU'),
            location: '',
            attendees: attendees.map(attendee => ({
                firstName: attendee.firstName,
                lastName: attendee.lastName,
                attended: ''
            })),
            tasks: assurance.map(task => ({
                taskID: task.taskID,
                taskName: task.name,
                status: task.status
            }))
        };

        console.log('[MeetingAgenda] Meeting agenda data:', data);

        await generateDocumentFromBase64(data);
    } catch (error) {
        console.error('Error generating meeting agenda:', error);
    }
}